module.exports = __webpack_public_path__ + "static/bottom_bar_5-d05eed6b81e6a990605014187ddc9cea.png";